import React from "react";

export const IconDefault = ({size = 20, ...props}) => {
	return (
		<svg
			height={size}
			viewBox="0 0 64 64"
			width={size}
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<g data-name="28_Cross">
				<path
					d="M45 27v14h-5V31l-.21-.27A12.526 12.526 0 0043.2 27zM24.21 30.73L24 31v10h-5V27h1.8a12.526 12.526 0 003.41 3.73z"
					fill="#f6dec2"
				/>
				<path
					d="M46 17a21.432 21.432 0 01-2.8 10 12.526 12.526 0 01-3.41 3.73A11.668 11.668 0 0137 32.18a14.506 14.506 0 01-5 .82 14.506 14.506 0 01-5-.82 11.668 11.668 0 01-2.79-1.45A12.526 12.526 0 0120.8 27 21.432 21.432 0 0118 17a2.006 2.006 0 012-2s1 15 12 15 12-15 12-15a2.015 2.015 0 012 2z"
					fill="#fff1d6"
				/>
				<path
					d="M44 15s-1 15-12 15-12-15-12-15h1a2.015 2.015 0 012 2s1 6 9 6c4 0 6.25-1.5 7.5-3a6.991 6.991 0 001.5-3 2.006 2.006 0 012-2z"
					fill="#fff1d6"
				/>
				<g fill="#e47e10">
					<path d="M18 17a21.432 21.432 0 002.8 10H10V17zM54 17v10H43.2A21.432 21.432 0 0046 17zM37 32.18V63H27V32.18a14.506 14.506 0 005 .82 14.506 14.506 0 005-.82z" />
				</g>
				<path
					d="M20.8 27A21.432 21.432 0 0118 17h-2.939a31.8 31.8 0 002.357 10zM46 17a21.432 21.432 0 01-2.8 10h3.382a31.8 31.8 0 002.357-10zM32 33a14.506 14.506 0 01-5-.82v4.093a17.557 17.557 0 0010 0V32.18a14.506 14.506 0 01-5 .82z"
					fill="#cf650d"
				/>
				<path
					d="M41 17a6.991 6.991 0 01-1.5 3c-1.25 1.5-3.5 3-7.5 3-8 0-9-6-9-6h4V1h10v16z"
					fill="#e47e10"
				/>
				<path
					d="M40.333 18.136C38.944 19.568 36.444 21 32 21c-5.092 0-7.625-1.878-8.866-3.483C23.588 18.968 25.438 23 32 23c4 0 6.25-1.5 7.5-3a7.364 7.364 0 001.366-2.483 7.063 7.063 0 01-.533.619z"
					fill="#cf650d"
				/>
				<path
					d="M45 27h-1.8a12.526 12.526 0 01-3.41 3.73L40 31v2.833a11.734 11.734 0 001-.742V39.5a.5.5 0 001 0v-7.318a11.989 11.989 0 001-1.168V36.5a.5.5 0 001 0v-7.039A10.6 10.6 0 0045 27zM20.8 27H19a10.6 10.6 0 001 2.461V36.5a.5.5 0 001 0v-5.486a11.989 11.989 0 001 1.168V39.5a.5.5 0 001 0v-6.409a11.734 11.734 0 001 .742V31l.21-.27A12.526 12.526 0 0120.8 27z"
					fill="#efc9b2"
				/>
				<path
					d="M32 32c-10.08 0-13.1-11.993-13.813-15.831A1.98 1.98 0 0018 17a21.432 21.432 0 002.8 10 12.526 12.526 0 003.41 3.73A11.668 11.668 0 0027 32.18a14.506 14.506 0 005 .82 14.506 14.506 0 005-.82 11.668 11.668 0 002.79-1.45A12.526 12.526 0 0043.2 27 21.432 21.432 0 0046 17a1.966 1.966 0 00-.187-.832C45.1 20 42.082 32 32 32z"
					fill="#f6dec2"
				/>
				<path
					d="M32 30c11 0 12-15 12-15h-.321C42.587 18.2 38.7 28 32 28s-10.587-9.8-11.679-13H20s1 15 12 15z"
					fill="#f6dec2"
				/>
			</g>
		</svg>
	);
}

export default IconDefault;
